import { lazyLoad } from 'utils/loadable';

export const JoinConfirmPage = lazyLoad(
  () => import('./index'),
  module => module.JoinConfirmPage,
);
